import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import BookingPage from "@/pages/BookingPage";
import SuccessPage from "@/pages/SuccessPage";
import CancelPage from "@/pages/CancelPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ServicePickerPreview from "@/pages/ServicePickerPreview";
import ErrorBoundary from "@/components/ErrorBoundary";
import { captureEntryParams } from "@/lib/analytics";
import "@/App.css";

function App() {
  // Snapshot the entry URL's UTM / click-id params the first time the app
  // mounts, so later redirects (payment success → WP thank-you page) can
  // forward them for GA4 attribution. Runs once per browser tab.
  useEffect(() => { captureEntryParams(); }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<BookingPage />} />
          <Route path="/booking/success" element={<SuccessPage />} />
          <Route path="/booking/cancel" element={<CancelPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/preview/service-picker" element={<ServicePickerPreview />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
